import * as React from "react";

const HeadsetIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2899_19240)"
    >
      <path d="M14 12.5v.5a2 2 0 0 1-2 2H8.5M14 8h-2a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h2zm0 0A6 6 0 0 0 2 8m0 0v3.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"></path>
    </g>
    <defs>
      <clipPath id="clip0_2899_19240">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default HeadsetIcon;
